import { render, staticRenderFns } from "./MemoInbox.vue?vue&type=template&id=a32c4886&"
import script from "./MemoInbox.vue?vue&type=script&lang=js&"
export * from "./MemoInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports